import { useParams } from "react-router-dom"
import AppRedirectScreen from "../components/AppRedirectScreen"

function GroupScreen() {
  const { id } = useParams()

  return <AppRedirectScreen type="group" deepLink={`pepchat://group/${id}`} />
}

export default GroupScreen
